import axios from './util/axios'

export function getLoyaltyCashPromotion () {
  return axios.get('/api/itempromotions/loyalty_cash_promotion/')
}
